module.exports = __webpack_public_path__ + "static/media/pr.159fd033.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/pr.svg
// module id = 2191
// module chunks = 0